<template>
  <div v-wave class=" flex w-full px-2 py-4 border-b justify-start items-center md:bg-white md:w-[400px] md:border md:rounded-md md:cursor-pointer hover:bg-gray-50">
    <Avatar
      :label="label"
      :icon="icon"
      size="large"
      class="bg-[#b798f5] rounded-2xl text-white flex-none"/>
    <div class="flex flex-col gap-1 pr-4 w-full pl-4">
      <div class="flex gap-2">
        <span class="subtitle-bold"> {{ title }}</span>
        <div v-if="titleIcons.length" class="flex gap-1 text-yellow-600 items-center">
          <i
            v-for="icn of titleIcons"
            :key="icn"
            style="font-size: 0.85rem"
            :class="['pi', icn]"/>
        </div>
        <Chip v-if="tag" :label="tag" class="leads-chip flex-none h-5 mr-auto text-xs w-max"/>
      </div>
      <span v-if="subtitle" class="text-sm text-gray-400">{{subtitle}}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {PropType} from "vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  icon: {
    type: String,
    required: false,
    default: ''
  },
  tag: {
    type: String,
    required: false,
    default: ''
  },
  subtitle: {
    type: String,
    required: false,
    default: ''
  },
  titleIcons: {
    type: Array as PropType<Array<string>>,
    required: false,
    default: () => []
  }
})
</script>

<style scoped lang="scss">
@use '../../../../../assets/css/vars' as *;

.leads-chip {
  border-color: $third-color;
  color: $third-color;
  @apply px-2 border bg-white;
}
</style>
